export default "__VITE_ASSET__CU8hHt8M__"